import { SCENARIO_LIMITS } from "consts";

import { CropYear } from "pages/app/scenario-analysis/types/scenario";
import { createEmptyYear } from "pages/app/scenario-analysis/utils/cropYearHelpers";

// pad with empty crop years so imports always meet the scenario minimum (filled years first) :D
export const padCropYearsToMinimum = (cropYears: CropYear[]): CropYear[] => {
  const padded = [...cropYears];
  while (padded.length < SCENARIO_LIMITS.MIN_YEARS) {
    padded.push(createEmptyYear(`field-import-pad-${padded.length + 1}`));
  }
  return padded;
};
